var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { faCheck, faExclamationCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FA_TIMES } from '../../../const/iconProps';
import { Container, IconWrapper, LeftBar, StyledCloseButton, ToastBody, ToastCloseIcon } from './subcomponents';
const generateIconFromType = (type) => {
    switch (type) {
        case 'error':
            return React.createElement(FontAwesomeIcon, { icon: faExclamationTriangle, size: "1x" });
        case 'success':
            return React.createElement(FontAwesomeIcon, { icon: faCheck, size: "1x" });
        default:
            return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle, size: "1x" });
    }
};
const Toast = (_a) => {
    var { children, className, closeHandler, type = 'info', hasIcon = true, hasClose = true, hasShadow = true, closeButtonAriaLabel = 'Dismiss Toast' } = _a, props = __rest(_a, ["children", "className", "closeHandler", "type", "hasIcon", "hasClose", "hasShadow", "closeButtonAriaLabel"]);
    const icon = generateIconFromType(type);
    return (React.createElement(Container, Object.assign({ className: className, type: type, hasShadow: hasShadow }, props),
        React.createElement(LeftBar, { type: type }),
        hasIcon && (React.createElement(IconWrapper, { type: type, title: type }, icon)),
        React.createElement(ToastBody, { type: type }, children),
        hasClose && closeHandler && (React.createElement(StyledCloseButton, { buttonType: "text", ariaLabel: closeButtonAriaLabel, onClick: closeHandler },
            React.createElement(ToastCloseIcon, { icon: FA_TIMES, size: "sm" })))));
};
export default Toast;
